export default __webpack_public_path__ + "close.183f6988.svg";